var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconRocket = function SvgIconRocket(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 508.1 508.1",
    style: {
      enableBackground: "new 0 0 508.1 508.1"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6B44B"
    },
    d: "M217.4,407.45c-2.4,4.6-5.2,9.1-8.2,13.3c-4.2,5.9-8.8,11.3-13.9,16.4 c-23.5,23.5-56.1,37.8-92.5,37.2c-0.1-7.5,0.6-14.9,1.7-22c-19.2,11-41.5,17.2-65.6,16.8c-0.3-24.1,5.9-46.4,16.8-65.6 c-7.1,1.1-14.5,1.8-22,1.6c-0.6-44.1,20.6-82.9,53.6-106.4c4.2-3,8.7-5.8,13.3-8.2c-0.1,0.5-0.2,1.1-0.3,1.6 c11.4,1.5,22.6,4.5,33.4,9c7.1,2.9,13.9,6.4,20.5,10.6c8.3,5.2,16.1,11.4,23.3,18.6s13.3,15,18.5,23.3c4.2,6.6,7.8,13.4,10.7,20.5 c4.5,10.8,7.5,22,9,33.4C216.4,407.65,216.9,407.55,217.4,407.45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05C"
    },
    d: "M206.8,374.35c-4.7,17.7-13.9,33.9-27.1,47.1c-14.5,14.5-32.6,24.2-52.3,28.4l6.1-39.6l-40,22.8 c-9.3,5.4-19.4,9.2-30,11.5c2.3-10.5,6.2-20.6,11.5-30l22.8-40l-39.6,6.1c4.2-19.7,13.9-37.8,28.4-52.3 c13.2-13.2,29.4-22.4,47.1-27.1c7.1,2.9,13.9,6.4,20.5,10.6c8.3,5.2,16.1,11.4,23.3,18.6s13.3,15,18.5,23.3 C200.3,360.45,203.9,367.25,206.8,374.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41596B"
    },
    d: "M200.7,508.05c2.6-2.2,5.3-4.6,7.8-7.2c25.1-25.1,38.8-57.2,41.2-90.1c3-39.8-10.7-80.7-41.2-111.2 s-71.3-44.2-111.2-41.2c-32.8,2.4-65,16.1-90.1,41.2c-2.5,2.5-4.9,5.2-7.2,7.8c4.8-38.3,21.8-75.4,51.2-104.8 c27.5-27.5,61.6-44.2,97.1-50.2c55.4-9.3,114.3,7.4,157.1,50.2c42.7,42.7,59.5,101.7,50.2,157.1c-6,35.6-22.7,69.7-50.2,97.1 C276.1,486.25,239,503.25,200.7,508.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#334A5E"
    },
    d: "M355.7,359.75c-32,22.1-67.6,39.6-105.9,51.1c3-39.8-10.7-80.7-41.2-111.2s-71.3-44.2-111.2-41.2 c11.5-38.4,29-74,51.1-105.9c55.4-9.3,114.3,7.4,157.1,50.2C348.2,245.35,365,304.35,355.7,359.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2705B"
    },
    d: "M215.9,407.75c-2.6-18.9-9.1-37.3-19.7-53.9c-5.2-8.3-11.4-16.1-18.6-23.3 c-7.2-7.2-15-13.4-23.3-18.6c-16.6-10.6-35-17.1-53.9-19.7c29.8-143.3,143.1-256.1,286.8-285c23.5-4.7,47.8-7.2,72.8-7.2h48.1v48.1 c0,24.9-2.5,49.3-7.2,72.8C472,264.65,359.2,377.95,215.9,407.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M397.6,110.55c-31.4-31.4-82.3-31.4-113.7,0c-15.7,15.7-23.6,36.3-23.5,56.9 c0.1,20.5,7.9,41.1,23.5,56.7s36.1,23.5,56.6,23.6c20.7,0.1,41.3-7.8,57-23.6C429,192.85,429,141.95,397.6,110.55z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#89D6F7"
    },
    cx: 340.8,
    cy: 167.35,
    r: 53.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41596B"
    },
    d: "M248.9,259.25L248.9,259.25L248.9,259.25c-53.5,18.8-112.1,77.4-130.8,130.8l0,0 C171.5,371.25,230.1,312.75,248.9,259.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#334A5E"
    },
    d: "M500.9,120.95L387.2,7.25c23.5-4.7,47.8-7.2,72.8-7.2h48.1v48.1 C508.1,73.05,505.6,97.45,500.9,120.95z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconRocket, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-rocket.c5d03ba6.svg";
export { ForwardRef as ReactComponent };